import { Box, styled } from '@mui/material';

export const MainContainer = styled(Box)(() => ({
  '& .title': {
    fontWeight: 700,
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: '0px',
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: 15,
  },
  '& .separator': {
    margin: '10px 0px 10px 0px',
  },
  '& .triggerCnt': {
    backgroundColor: 'rgba(255, 240, 242, 1)',
    border: '1px solid #E0E0E0',
    borderRadius: '6px',
    padding: '12px 12px',
    '& .procedure-item-type': {
      border: 'none',
      padding: '0px',
    },
  },
  '& .actionCnt': {
    marginTop: '10px',
    backgroundColor: 'rgba(241, 241, 255, 1)',
    border: '1px solid #E0E0E0',
    borderRadius: '6px',
    padding: '15px 12px',

    '& .creationTitle': {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '100%',
      letterSpacing: '0.15px',
      color: 'rgba(33, 33, 33, 1)',
    },
    '& .creationDescription': {
      fontWeight: 700,
      fontSize: 13,
      lineHeight: '100%',
      letterSpacing: '0px',
      color: 'rgba(78, 72, 250, 1)',
    },
  },

  '& .paperBox': {
    width: '100%',
    padding: 10,
    marginBottom: 15,
  },
}));
